const moment = require('moment-timezone');

/** Sort key for route sequence: actual pickup when complete, else reservation time. */
export const getRouteViewJobSortTime = job => {
  if (job?.status == 8 && moment(job.pickup_time).isValid()) {
    return moment.utc(job.pickup_time).valueOf();
  }
  if (moment(job?.reservation_time).isValid()) {
    return moment.utc(job.reservation_time).valueOf();
  }
  return 0;
};

/** API often returns newest-first; route sequence and map connectors need earliest-first. */
export const sortRouteViewJobsChronologically = jobs => {
  if (!jobs?.length) {
    return [];
  }
  return [...jobs].sort((a, b) => {
    const diff = getRouteViewJobSortTime(a) - getRouteViewJobSortTime(b);
    if (diff !== 0) {
      return diff;
    }
    return (a?.id || 0) - (b?.id || 0);
  });
};
